import React from "react";

import { Box, Typography } from "@mui/material";

export default function LogInReminder() {
  return (
    <Box display="flex" height="100%">
      <Typography variant="h6" fontSize="30px" margin="auto">
        Log in with Google!
      </Typography>
    </Box>
  );
}
